export enum RestrictionType {
  DOCUMENT_SENDING = 'DOCUMENT_SENDING'
}

export interface SubscriptionData {
  restrictions: RestrictionType[];
}

